/**
 * Thin wrappers that reuse the existing MisVentasPage and WalletPage inside
 * the new gestor portal (`/remesas/*`). The original pages and routes remain
 * untouched in case the admin shell needs them too.
 */
import { useAuth } from '@/contexts/AuthContext';
import { useParams } from 'react-router-dom';
import MisVentasPage from '@/pages/MisVentasPage';
import WalletPage from '@/pages/WalletPage';

// MisVentasPage already reads the current user via useAuth — no params needed.
export const GestorMisPasajerosPage = () => <MisVentasPage />;

// WalletPage expects a `gestorId` route param. The portal version pins it
// to the logged-in gestor — they can never see another gestor's wallet.
export const GestorMiWalletPage = () => {
  const { user } = useAuth();
  // Touch useParams so the WalletPage's router context is mounted.
  useParams();
  return <WalletPage forcedGestorId={user?.id} />;
};
